/**
 * Convert a system_name like "center_team_alignment" into a readable display
 * name like "Team Alignment". Strips the canonical `center_` prefix and
 * Title Cases the remaining tokens. Safe fallback when a `displayName` from
 * the API isn't yet available (loading / missing translation key).
 */
export function formatSystemName(systemName: string): string {
  return systemName
    .replace(/^center_/, '')
    .replaceAll('_', ' ')
    .replaceAll(/\b\w/g, (c) => c.toUpperCase());
}
